module.exports = __webpack_public_path__ + "arabesque2.c23564a66c8e5fe68e43.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/theme/arabesque2.png
// module id = 637
// module chunks = 1